export function haveIntakeFormChanges(initialFormIds: unknown[], currentFormIds: unknown[]): boolean {
  const normalize = (ids: unknown[]) => ids.map(String).sort()

  return JSON.stringify(normalize(initialFormIds)) !== JSON.stringify(normalize(currentFormIds))
}
